import Vue from 'vue'
import VueRouter from 'vue-router'
import {
    setToken,
    removeToken,
    setName,
    removeName,
    // baseURL
} from './require/auth'
import store from './store'
import $ from 'jquery'
Vue.use(VueRouter)

// 解决vue-router在3.0版本以上重复点击路由报错的问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
import axios from "./require/axios";

const Login = () =>
    import ('@/views/login.vue')
const Home = () =>
    import ('@/views/home.vue')
const Subpage = () =>
    import ('@/views/subpage.vue')
const List = () =>
    import ('@/views/lists/list.vue')
const Subject = () =>
    import ('@/views/subject.vue')
const Lists = () =>
    import ('@/views/lists/lists.vue')
const Field = () =>
    import ('@/views/lists/field.vue')
const Column = () =>
    import ('@/views/lists/column.vue')
const Visibility = () =>
    import ('@/views/lists/visibility.vue')
const Expert = () =>
    import ('@/views/lists/expert.vue')
const Detail = () =>
    import ('@/views/detail.vue')
const Download = () =>
    import ('@/views/download.vue')
const Introduce = () =>
    import ('@/components/introduce.vue')

const routes = [{
        path: '/login',
        component: Login,
        name: 'login'
    },
    {
        path: '/',
        component: Home,
        name: 'home',
        redirect: to => {
            if (to.name === 'home') {
                return {
                    path: '/list'
                }
            }
        },
    },
    {
        path: '/list',
        component: Subpage,
        name: 'subpage',
        children: [{
                path: '/list',
                component: List,
                name: 'list',
            },
            {
                path: '/field',
                component: Field,
                name: 'field',
            }
        ]
    },
    {
        path: '/subject',
        component: Subject,
        name: 'subject',
        children: [{
            path: '/subject',
            component: Lists,
            name: 'lists',
        }]
    },
    {
        path: '/column',
        component: Column,
        name: 'column',
    },
    {
        path: '/visibility',
        component: Visibility,
        name: 'visibility'
    },
    {
        path: '/expert',
        component: Expert,
        name: 'expert'
    },
    {
        path: '/detail',
        component: Detail,
        name: 'detail'
    },
    {
        path: '/download',
        component: Download,
        name: 'download'
    },
    {
        path: '/introduce',
        component: Introduce,
        name: 'introduce'
    }
]
const router = new VueRouter({
    routes
})

function comFun(to) {
    let strS = ['/column', '/expert', '/detail', '/download', '/login']
        // 统一请求词云数据
    if (strS.indexOf(to.path) === -1) {
        setTimeout(() => {
            if (store.state.wordCloudData.length === 0) {
                let wordCloudData = [];
                return axios({
                    method: "get",
                    url: "http://expert.drcnet.com.cn/expert/api/aggregation/keyword/nameList"
                }).then(res => {
                    if (res.data.code === 0) {
                        res.data.data.forEach(item => {
                            wordCloudData.push({
                                name: item[0],
                                value: item[1]
                            });
                        });
                        store.commit("updateWordCloudData", wordCloudData);
                    }
                });
            }
        }, 500);
    }
}
// 有设备号判断用户是否登录
// function judgeLogin() {
//     return axios({
//         method: "get",
//         url: encodeURI(
//             `${baseURL}/CommonController/common/checkClientToken?guid=${localStorage.getItem('murmur')}`
//         )
//     }).then(res => {
//         if (res.data.data === null) {
//             removeName()
//             removeToken()
//         } else {
//             setName(res.data.data.userName)
//             setToken(res.data.data.token)
//         }
//     })
// }
// 判断用户是否登录
function judgeLogin() {
    $.ajax({
        // url: 'http://d.drcnet.com.cn/eDRCnet.common.web/login/login.ashx?flag=initp',
        url: `http://user.drcnet.com.cn/userapi/loginController/initLoginP?flag=initp&guid=${localStorage.getItem('murmur')}`,
        type: 'get',
        dataType: 'jsonp',
        jsonpCallback: 'showData',
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        async: false,
        success: function(data) {
            if (data.Logined === 0) {
                removeName()
                removeToken()
            } else {
                setName(data.UserName)
                setToken(data.UserToken)
            }
        }
    })
}
router.beforeEach((to, from, next) => {

    // 埋点系统 start
    // if (to.path !== '/detail' && to.path !== '/download') {
    //     try {
    //         if (LogCollection) {
    //             LogCollection.end()
    //         }
    //     } catch (e) {
    //         // LogCollection.init()
    //     }
    // }
    // 埋点系统 end


    // return
    if (to.name == "detail") {
        // 获取路由参数
        const params = to.query
            // 构造外部链接（示例）
        const externalUrl = `https://d.drcnet.com.cn/?docid=${params.docid}&leafid=${params.leafid}`
            // 跳转外部链接
        window.location.href = externalUrl

        // 阻止导航继续
        next(false)
    } else {
        next()
    }
    store.commit("updateFromPathName", from.name);
    comFun(to)
        // 未登录情况下可以看的页面
    if (to.path === '/login' || to.path === '/detail' || to.path === '/download') {
        judgeLogin()
        next()
            // 进入首页
            // } else if (to.path === '/') {
            //     comFun(to)
            //     next()
            //     // 其他页面
    } else {
        $.ajax({
            // url: 'http://d.drcnet.com.cn/eDRCnet.common.web/login.ashx?flag=initp',
            url: `http://user.drcnet.com.cn/userapi/loginController/initLoginP?flag=initp&guid=${localStorage.getItem('murmur')}`,
            type: 'get',
            dataType: 'jsonp',
            jsonpCallback: 'showData',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            async: false,
            success: function(data) {
                if (data.Logined === 0) {
                    removeName()
                    removeToken()
                    next({
                        path: "/login"
                    });
                } else {
                    setName(data.UserName)
                    setToken(data.UserToken)
                    comFun(to)
                    next()
                }
            }
        })
    }
})
router.afterEach((to) => {
    if (to.path !== '/detail' && to.path !== '/download') {
        try {
            if (LogCollection) {
                LogCollection.end()
            }
        } catch (e) {
            // LogCollection.init()
        }
    }
    // if (to.path !== '/detail' && to.path !== '/download') {
    //     try {
    //         if (LogCollection) {
    //             LogCollection.init()
    //         }
    //     } catch (e) {
    //         console.log(e)
    //     }
    // }
})
export default router